import { z } from "zod";
import { AddressSchema } from "./companies";
import { ExternalMappingSchema } from "./externalMappings";

export const LocationSchema = z.object({
  id: z.string(),
  organizationId: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  address: AddressSchema.nullable(),
  logoUrl: z.string().nullable().optional(),
  externalMappings: z.array(ExternalMappingSchema).default([]),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type Location = z.infer<typeof LocationSchema>;

export const CreateLocationParamsSchema = z.object({
  name: z.string(),
  description: z.string().nullable().optional(),
  address: AddressSchema.nullable().optional(),
  logoAssetId: z.string().nullable().optional(),
});
export type CreateLocationParams = z.infer<typeof CreateLocationParamsSchema>;

export const UpdateLocationParamsSchema = z.object({
  name: z.string().optional(),
  description: z.string().nullable().optional(),
  address: AddressSchema.nullable().optional(),
  logoAssetId: z.string().nullable().optional(),
});
export type UpdateLocationParams = z.infer<typeof UpdateLocationParamsSchema>;

export const DEFAULT_LOCATION_LIST_LIMIT = 50;

export const LocationFilterSchema = z.object({
  search: z.string().optional(),
  limit: z.number().int().positive().optional(),
  offset: z.number().int().nonnegative().optional(),
});
export type LocationFilter = z.infer<typeof LocationFilterSchema>;

export const ListLocationsResponseSchema = z.object({
  locations: z.array(LocationSchema),
  total: z.number(),
});
export type ListLocationsResponse = z.infer<typeof ListLocationsResponseSchema>;

export const GetLocationResponseSchema = z.object({
  location: LocationSchema,
});
export type GetLocationResponse = z.infer<typeof GetLocationResponseSchema>;

export const CreateLocationResponseSchema = z.object({
  location: LocationSchema,
});
export type CreateLocationResponse = z.infer<
  typeof CreateLocationResponseSchema
>;

export const UpdateLocationResponseSchema = z.object({
  location: LocationSchema,
});
export type UpdateLocationResponse = z.infer<
  typeof UpdateLocationResponseSchema
>;

export const DeleteLocationResponseSchema = z.object({
  success: z.boolean(),
});
export type DeleteLocationResponse = z.infer<
  typeof DeleteLocationResponseSchema
>;
